import styled, { css } from 'styled-components'
import TextField from '@mui/material/TextField'

export const TextFieldComponent = styled(TextField)(
  ({ theme }) => css`
    .MuiInputBase-root {
      border-color: ${theme.colors.primary.main};
    }
    label,
    input {
      font-size: ${theme.typograph.fontsize.h3};
      font-family: ${theme.typograph.fontFamily.primary};
    }
    label {
      &.MuiInputLabel-shrink {
        background-color: ${theme.colors.base.white};
        padding-right: ${theme.layout.padding.small};
      }
    }

    & label.Mui-focused {
      color: ${theme.colors.primary.main};
    }
    & .MuiInput-underline:after {
      border-bottom-color: ${theme.colors.primary.main};
    }
    & .MuiOutlinedInput-root {
      &.Mui-focused fieldset {
        border-color: ${theme.colors.primary.main};
      }
    }
  `
)
